/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "firebase/analytics";

export const onRouteUpdate = ({ location }, pluginOptions = {}) => {
  if (process.env.NODE_ENV !== `production`) {
    return null
  }

  (function (w, d, n, s, t) {
    w[n] = w[n] || [];
    w[n].push(function () {
      Ya.Context.AdvManager.render({
        blockId: "R-A-599273-1",
        renderTo: "yandex_rtb_R-A-599273-1",
        async: true
      });
    });
    w[n].push(function () {
      Ya.Context.AdvManager.render({
        blockId: "R-A-599273-3",
        renderTo: "yandex_rtb_R-A-599273-3",
        async: true
      });
    });
    w[n].push(function () {
      Ya.Context.AdvManager.render({
        blockId: "R-A-599273-4",
        renderTo: "yandex_rtb_R-A-599273-4",
        async: true
      });
    });
    t = d.getElementsByTagName("script")[0];
    s = d.createElement("script");
    s.type = "text/javascript";
    s.src = "//an.yandex.ru/system/context.js";
    s.async = true;
    t.parentNode.insertBefore(s, t);
  })(window, window.document, "yandexContextAsyncCallbacks");

  return null
}
